import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

import {
  getSessionId,
  getSelectedPromocode,
} from "../../utils/SettingsRetriever";
import request from "../../utils/request";

import moment from "moment";

import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Popper from "@material-ui/core/Popper";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import CircularProgress from "@material-ui/core/CircularProgress";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

import SpotlioIcon from "../../components/Icon";
import Input from "../../components/Input";

import ListGroups from "../../components/List/Activities/groups";
import SearchingScreen from "../../components/Layout/SearchingScreen";
import Currency from "../../components/Currency";
import SEO from "../../components/Seo";
import Modal from "../../components/Modal";
import Dialog from "../../components/Dialog";
import TabGenerator from "../../components/Layout/HeaderTabs/TabGenerator";
import TotalDueNow from "../../components/TotalDueNow";
import Products from "../../components/List/Cart/products";
import NumericStepper from "../../components/NumericStepper";
import QuantitySelector from "../../components/QuantitySelector";
import TextField from "../../components/TextField";
import Breadcrumb from "../../components/Breadcrumb";
import SpotlioButton from "../../components/Button";
import ActivitiesModal from "../../components/ActivitiesModal";

import { getSystemSettings, setSessionId, setCartLength } from '../../utils/SettingsRetriever';
import { getCookie, deleteCookie } from '../../utils/CookiesRetriever';
import SalesIDRetriever from '../../utils/SalesIDRetriever';
import QueryStringRetriever from '../../utils/QueryStringRetriever';
import { getBundle, updateBundleAmount, toggleBundleModal, addBundleProducts, addBundleToCart } from '../../utils/Bundle';
import LocaleAsString from '../../LocaleEngine/LocaleAsString';
import IntlMessage from '../../LocaleEngine';
import { GAPageView, GAEvent, gtmFunction } from '../../utils/ga';
import { track as FBPXtrack } from '../../utils/fbpixel';
import PushHistory from '../../utils/PushHistory';
import { slugify } from "../../utils/string";
import QS from "../../utils/QueryStringRetriever";
import getDateFormat from "../../utils/DateFormatRetriever";
import {
  getItinerary as globalGetItinerary,
  add as cartServiceAdd,
  addPackage as globalAddPackage,
  remove as globalRemove,
  retrieveDestinationFromCart
} from "../../services/cart";
import { getCheckoutEntrypoint } from "../../helpers/urls";

// import history from '../../history';

import "./index.scss";

let CancelToken = axios.CancelToken;
let source = CancelToken.source();
export default class Cart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cart: [],
      loading: true,
      total: 0,
      taxes: 0,
      taxesList: [],
      deletedItem: {},
      deletedPackage: {},
      itineraryId: 0,
      categories: getSystemSettings(),
      taxesModal: false,
      removeItemModal: false,
      removePackageModal: false,
      itinerarySaved: false,
      itinerarySavedDiag: false,
      b2bCookie: JSON.parse(getCookie("b2b")),
      saveItineraryMenuDisplay: false,
      saveItineraryMenuSelectedIndex: 0,
      needGuest: false,
      savings: 0,
      amountToDelete: undefined,
      bundleObject: {
        bundles: [],
        bundleModal: [],
        currentIndexModal: null,
        productNameBundle: [],
        incorrectAmount: false,
      },
      loadingBundle: false,
      selectedPackage: {},
      promocodeForm: {
        code: "",
        added: false,
        error: false,
      },
      steps: {
        list: [
          "cart.general.step.1",
          "cart.general.step.2",
          "cart.general.step.3",
          "cart.general.step.4",
          "cart.general.step.5",
        ],
        current: 1,
      },
      b2cSaveItinerary: false,
      b2cSaveItineraryForm: {},
      b2cSaveItineraryLoading: false,
      successfullySavedB2CItinerary: false,
      loadingSaveItinerary: false,
      open: null,
      activitiesModal: false,
      checkoutDrawer: true,
      width: window.innerWidth,
      selectedDate: null,
    };

    const query = QueryStringRetriever();
    if (query.needGuest) {
      this.state.needGuest = true;
    }
  }

  triggerModalEvent = (nextAction = false) => {
    if (typeof CustomEvent !== "function")
      // eslint-disable-next-line
      CustomEvent = (event, params) => {
        params = params || { bubbles: false, cancelable: false, detail: null };
        var evt = document.createEvent("CustomEvent");
        evt.initCustomEvent(
          event,
          params.bubbles,
          params.cancelable,
          params.detail
        );
        return evt;
      };

    var event = new CustomEvent("triggerAttachGuestsModal");
    event.action = nextAction;
    document.dispatchEvent(event);
  };

  handleFormChange = (name, form) => (event) => {
    let state = this.state;
    state[form] = { ...state[form], [name]: event.target.value, error: "" };
    this.setState(state);
  };

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
    if (QS().sessionid) {
      setSessionId(QS().sessionid);
      this.getItinerary();
    } else {
      this.getItinerary();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  updateDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  pageView() {
    let layer = {
      itineraryid: this.state.itineraryId,
      subtotal: this.state.total,
      tax: this.state.taxes,
      total: this.state.total + this.state.taxes,
      result: "OK",
      products: [],
    };

    this.state.cart.forEach((products) => {
      products.items.forEach((item) => {
        layer.products.push(item);
      });
    });

    if(this.props.readOnly) {
      gtmFunction("purchase", layer, false, "Cart")

      GAPageView({
          globalSettings: getSystemSettings(),
          sectionSettings: {
              type: 'completed-booking',
              title: 'completed booking'
          },
          sessionId: getSessionId(),
          data:  {
            ...layer,
            products: this.transformProducts(layer.products)
          }
      });

      FBPXtrack({
          globalSettings: getSystemSettings(),
          event: 'completed-booking',
          data:  {
            ...layer,
            products: this.transformProducts(layer.products)
          }
      });
  } else {
      GAPageView({
        globalSettings: getSystemSettings(),
        sectionSettings: {
          type: "cart",
          title: "shopping cart",
        },
        sessionId: getSessionId(),
        data:  {
          ...layer,
          products: this.transformProducts(layer.products)
        }
      });

      FBPXtrack({
        globalSettings: getSystemSettings(),
        event: "cart",
        data:  {
          ...layer,
          products: this.transformProducts(layer.products)
        }
      });
    }
  }

  transformProducts = (products) => {
    const transformedProducts = []
    let priceMode = "total";
    if (
      getSystemSettings().analytics &&
      getSystemSettings().analytics.config &&
      getSystemSettings().analytics.config.price
    ) {
      priceMode = getSystemSettings().analytics.config.price;
    }

    if (Array.isArray(products)) {
      products.forEach(item => {
        let itemPrice = parseFloat(item.Price);
        if (priceMode === "unitPrice") {
          itemPrice = itemPrice / item.Quantity;
        }

        transformedProducts.push({
            itineraryItemId: item.ItineraryItemId,
            sku: item.SKU,
            name: item.ProductName,
            category: item.CategoryName,
            price: parseFloat(itemPrice),
            quantity: item.Quantity,
            arrival_date: item.ArrivalDate,
            departure_date: item.DepartureDate,
            _PackageID: item.PackageId,
            _PackageName: item.PackageName,
            _AssociatedItineraryItemID: item.ParentItemId,
        })
      })
    }

    return transformedProducts;
  }

  toggleSupplier = (index) => {
    if (index === this.state.open) {
      this.setState({ open: null });
    } else {
      this.setState({ open: index });
    }
  };

  getItinerary = (action = false) => {
    let params = { bundle: 1 };

    if (action === "delete" || action === "add") {
      params.reload = true;
    }

    globalGetItinerary(params).then((response) => {
      retrieveDestinationFromCart(response.items)
      let taxesfees = 0;
      let total = 0;
      let savings = 0;
      let selectedPackage = this.state.selectedPackage;
      let itineraryId;
      let reserved;
      let addMoreModal;
      let cart = [];
      let taxes = [];
      if (response.items) {
        cart = response.items;
        taxes = response.fees;

        cart.forEach((agrupation, idx) => {
          agrupation.items.forEach((item) => {
            total += parseFloat(item.Price);
            savings += parseFloat(item.OriginalPrice - item.Price);
          });
        });
        taxes.forEach((tax) => {
          tax.Amount ? (taxesfees += tax.Amount) : (taxesfees += tax.price);
        });

        if (response.selectedPackage) {
          selectedPackage = response.selectedPackage;
        }
        if (cart.length > 0) {
          itineraryId = response.itineraryid;
          reserved = response.reserved;
        }
      }
      if (action === "add") {
        addMoreModal = false;
      }

      if (!action) {
        gtmFunction("view_cart", this.getItemsFromResponse(response), total, "Cart")
      }

      this.setState(
        {
          total,
          savings,
          taxes: taxesfees,
          loading: false,
          cart,
          taxesList: taxes.sort(this.compareTax),
          loadingBundle: false,
          selectedPackage,
          bundleObject: toggleBundleModal(this.state.bundleObject, false),
          itineraryId,
          reserved,
          addMoreModal,
        },
        () => {
          this.getAffirm();
        }
      );
      this.pageView();
    });
  };

  getItemsFromResponse = (response) => {
    let items = [];
    if (!response || !response.items) return [];
    response.items.forEach(group => {
      group.items.forEach(item => {
        items.push(item);
      })
    })

    return items;
  }

  getAffirm = () => {
    let system = getSystemSettings();
    let totalPrice = this.state.total + this.state.taxes;
    if (
      system.payment &&
      system.payment.affirm &&
      system.payment.affirm &&
      system.payment.affirm &&
      totalPrice >= system.payment.affirm.threshold
    ) {
      request({
        url: `${system.payment.affirm.apiBaseUrl}/api/promos/v2/${
          system.payment.affirm.key
        }?amount=${
          totalPrice * 100
        }&field=ala&logo_color=blue&logo_type=logo&page_type=cart&show_cta=false`,
        method: "GET",
      }).then((response) => {
        if (response.data && response.data.promo && response.data.promo.ala) {
          this.setState({
            affirmData: response.data.promo.ala.replace("Affirm", ""),
          });
        } else {
          this.setState({ affirmData: false });
        }
      });
    }
  };

  getBundle(productBundle) {
    this.setState({ loadingBundle: true }, () => {
      getBundle(productBundle).then((r) => {
        if (!r) {
          this.setState({ loadingBundle: false });
          return;
        }
        this.setState({ ...this.state, bundleObject: r, loadingBundle: false });
      });
    });
  }

  addToPackage(element, amount, callback) {
    let itineraryItems = [];
    let itineraryItem = {
      ArrivalDate: this.state.modalComponent.SearchDate,
      DepartureDate: this.state.modalComponent.SearchDate,
      AdultCount: 1,
      ChildCount: 0,
      SupplierId: element.SupplierId,
      ProductId: element.ProductId,
      Quantity: amount,
      PackageComponentId: this.state.modalComponent.ComponentId,
    };

    itineraryItems.push(itineraryItem);

    globalAddPackage({
      itineraryitems: JSON.stringify(itineraryItems),
      packageId: this.state.selectedPackage.PackageId,
      productWithFullInfo: [{ ...element, Quantity: amount }]
    }).then((response) => {
      if (response.UpsellItemList && response.UpsellItemList !== "") {
        this.getBundle(response.UpsellItemList);
      } else {
        this.getItinerary("add");
      }
    });
  }

  addToCart(element, amount, callback) {
    let items = [];
    let item = {
      ArrivalDate: element.ArrivalDate,
      DepartureDate: element.DepartureDate,
      AdultCount: 1,
      ChildCount: 0,
      SalesId: SalesIDRetriever(),
      SupplierId: element.SupplierId,
      ProductId: element.ProductId,
      Quantity: amount,
      hasTotalPrice: true,
    };
    items.push(item);
    cartServiceAdd({
      itineraryitems: JSON.stringify(items),
      productWithFullInfo: element,
      pageTitle: "Cart"
    })
      .then(() => {
        this.getItinerary("add");
      })
      .then(callback);
  }

  compareTax = (a, b) => {
    if (!a.Amount) {
      if (a.price < b.Amount) {
        return -1;
      }
      if (a.price > b.Amount) {
        return 1;
      }
    } else if (!b.Amount) {
      if (a.Amount < b.price) {
        return -1;
      }
      if (a.Amount > b.price) {
        return 1;
      }
    } else {
      if (a.Amount < b.Amount) {
        return -1;
      }
      if (a.Amount > b.Amount) {
        return 1;
      }
    }

    return 0;
  };

  gotoRegister = () => {
    GAEvent("Checkout", "click");
    let displayRequiredItemTypes = false;
    let requiredItemTypes = false;
    if (
      getSystemSettings().app &&
      getSystemSettings().app.checkout &&
      getSystemSettings().app.checkout.checkoutRequiredItemTypes &&
      getSystemSettings().app.checkout.checkoutRequiredItemTypes.enabled
    ) {
      let { types } =
        getSystemSettings().app.checkout.checkoutRequiredItemTypes;
      types.forEach((type) => {
        this.state.cart.forEach((agrupation) => {
          if (
            agrupation.items.find((item) => item.SuperCategoryId === type.type)
          ) {
            type.enabled = false;
          }
        });
        if (type.enabled !== false) {
          type.enabled = true;
          displayRequiredItemTypes = true;
        }
      });
      requiredItemTypes = types;
      this.setState({ requiredItemTypes, displayRequiredItemTypes });
    }
    if (displayRequiredItemTypes) return;
    this.setState({ ...this.state, loadingPayment: true }, () => {
      if (JSON.parse(getCookie("b2b"))) {
        request({
          url: getSystemSettings().api + "/inntopia/travel-agent/guest/current",
          method: "POST",
          data: {
            token: JSON.parse(getCookie("b2b")).token.token,
            salesId: SalesIDRetriever(),
          },
        }).then((response) => {
          if (response.status === 200) {
            PushHistory("/checkout/payment");
          } else {
            this.setState({ ...this.state, loadingPayment: false }, () =>
              this.triggerModalEvent()
            );
          }
        });
      } else {
        PushHistory(getCheckoutEntrypoint());
      }
    });
  };

  checkAddOn = () => {
    const { cart } = this.state;

    let settings = getSystemSettings();
    let ModalShouldBeShown = false;
    if (settings.app && settings.app.modal && settings.app.modal.enabled) {
      ModalShouldBeShown = true;
    }
    const dontShowModalIfCartAlreadyHaveA =
      settings.app &&
      settings.app.modal &&
      settings.app.modal.dontShowModalIfCartAlreadyHaveA;
    if (dontShowModalIfCartAlreadyHaveA) {
      cart.forEach((el) => {
        if (el.name === dontShowModalIfCartAlreadyHaveA)
          ModalShouldBeShown = false;
      });
    }
    if (ModalShouldBeShown) {
      this.setState({ activitiesModal: 1 });
    } else {
      this.gotoRegister();
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.loading === true && this.state.loading === false) {
      this.setState({ loading: nextProps.loading });
    }
    if (nextProps.loading === "finished" && this.state.loading !== "finished") {
      this.getItinerary();
    }
  }

  removeItemModalOpen = (item, value) => {
    this.setState({ deletedItem: item }, () => {
      this.setState({
        removeItemModal: value,
        amountToDelete:
          value === false ? undefined : this.getMinQuantityDelete(item),
      });
    });
  };

  removePackageModalOpen = (Package, value) => {
    this.setState({ deletedPackage: Package }, () => {
      this.setState({ removePackageModal: value });
    });
  };

  taxesModalOpen = (value) => {
    if (this.state.taxes > 0) {
      this.setState({ ...this.state, taxesModal: value });
    }
  };

  handleDeleteItem = (quantity) => {
    this.setState({ loading: true, removeItemModal: false });
    if (quantity) {
      for (let i = 0; i < quantity; i++) {
        globalRemove({
          itemId: this.state.deletedItem.ItineraryItemsIds[i],
          productWithFullInfo: { ...this.state.deletedItem, Quantity: quantity, Price: this.getPrice(this.state.deletedItem, quantity) },
          isLast: i + 1 === quantity
        }).then(() => {
          if (i + 1 === quantity) {
            this.getItinerary("delete");
          }
        });
      }
    } else {
      globalRemove({
        itemId: this.state.deletedItem.ItineraryItemId,
        productWithFullInfo: this.state.deletedItem
      }).then(() => {
        this.getItinerary("delete");
      });
    }
  };

  getPrice = (item, quantity) => {
    if (item.Quantity !== quantity) {
      return parseFloat(item.Price) / item.Quantity * quantity;
    }

    return parseFloat(item.Price);
  }

  handleDeletePackage = () => {
    this.setState({ loading: true, removePackageModal: false });
    let packageId = this.state.deletedPackage.items[0].PackageId;
    this.state.cart.forEach((products) => {
      products.items.forEach((item) => {
        if (item.PackageId === packageId) {
          let requests = item.ItineraryItemsIds.map((id) => {
            return this.removeItemFromCart(id, item).catch(function (error) {
              console.error(error);
            });
          });
          Promise.all(requests).then(() => {
            // setCartLength(getCartLength() - this.state.deletedItem.Quantity)
            this.getItinerary("delete");
          });
        }
      });
    });
  };

  removeItemFromCart = (id, item) => {
    return new Promise((resolve, reject) => {
      globalRemove({
        itemId: id,
        productWithFullInfo: item
      })
        .then(() => {
          resolve(true);
        })
        .catch(() => {
          reject(false);
        });
    });
  };

  saveItinerary = (nextAction) => {
    if (this.state.b2bCookie || getSystemSettings().app.cart.continueShopping) {
      if (nextAction === "Continue Shopping") {
        const selectedPromocode = getSelectedPromocode();
        const pkgName = slugify(selectedPromocode.name);
        PushHistory(
          "/packages/" +
            pkgName +
            "/" +
            selectedPromocode.inntopiaPackageId +
            "?ref=cart"
        );
        return true;
      } else {
        this.setState({ ...this.state, loadingSaveItinerary: true }, () => {
          request({
            url:
              getSystemSettings().api + "/inntopia/travel-agent/guest/current",
            method: "POST",
            data: {
              token: this.state.b2bCookie.token.token,
              salesId: SalesIDRetriever(),
            },
          }).then((result) => {
            this.setState(
              { ...this.state, loadingSaveItinerary: false },
              () => {
                if (result.status === 200) {
                  request({
                    url: getSystemSettings().api + "/inntopia/cart/save",
                    method: "POST",
                    data: {
                      sessionId: getSessionId(),
                      salesId: SalesIDRetriever(),
                    },
                  }).then((data) => {
                    if (data.status === 200) {
                      // this.setState({itinerarySaved: true});
                      switch (nextAction) {
                        case "Save & Checkout":
                          PushHistory("/checkout/payment");
                          break;
                        case "Save & Continue":
                          this.setState({
                            ...this.state,
                            itinerarySavedDiag: true,
                          });
                          break;
                        case "Save & Close":
                          this.regenerateSessionAndRedirect();
                          break;
                        default:
                          break;
                      }
                    }
                  });
                } else {
                  this.triggerModalEvent(nextAction);
                }
              }
            );
          });
        });
      }
    } else {
      if (!this.state.b2cSaveItineraryForm.email) {
        return null;
      } else {
        if (
          this.state.b2cSaveItineraryError ||
          this.state.successfullySavedB2CItinerary
        ) {
          this.setState({
            ...this.state,
            b2cSaveItineraryError: false,
            successfullySavedB2CItinerary: false,
            b2cSaceItinerary: false,
            b2cSaveItineraryLoading: false,
          });
        } else {
          this.setState(
            {
              ...this.state,
              b2cSaveItineraryLoading: true,
            },
            () => {
              request({
                url: "https://vvdb2732de.execute-api.us-east-1.amazonaws.com/send",
                method: "POST",
                data: {
                  sessionid: getSessionId(),
                  salesid: SalesIDRetriever(),
                  itineraryid: this.state.itineraryId,
                  ...this.state.b2cSaveItineraryForm,
                },
              })
                .then((response) => {
                  if (response.data) {
                    this.setState({
                      ...this.state,
                      successfullySavedB2CItinerary: true,
                      b2cSaveItineraryLoading: false,
                      b2cSaveItineraryForm: {},
                    });
                  } else {
                    throw Error();
                  }
                })
                .catch((err) => {
                  this.setState({
                    ...this.state,
                    b2cSaveItineraryError: "Could not save itinerary",
                    b2cSaveItineraryLoading: false,
                    b2cSaveItineraryForm: {},
                  });
                });
            }
          );
        }
      }
    }
  };

  regenerateSessionAndRedirect = () => {
    request({
      url:
        getSystemSettings().api +
        "/inntopia/session?salesid=" +
        SalesIDRetriever(),
      method: "GET",
    }).then((result) => {
      deleteCookie("b2b");
      deleteCookie('b2btato');
      deleteCookie('b2bagent');
      setSessionId(result.data.SessionId);
      setCartLength(0);
      PushHistory("/b2b");
    });
  };

  handleSaveItineraryButtonClick = (index) => {
    this.saveItinerary(index);
  };

  handleSaveItineraryMenuDisplay = (state) => {
    if (!state) state = !this.state.saveItineraryMenuDisplay;
    this.setState({ ...this.state, saveItineraryMenuDisplay: state });
  };

  getPackageUpselling = (component, componentData, startDate = false) => {
    let { PackageId, ComponentId } = component;
    let selectedPromocode = getSelectedPromocode();
    let lodgingFromPackage = undefined;
    let form = {
      arrivalDate: moment.utc(componentData.arrival).format("YYYY-MM-DD"),
      departureDate: moment.utc(componentData.departure).format("YYYY-MM-DD"),
      adults: componentData.adults,
      children: componentData.children,
    };

    this.state.cart.forEach((agrupation) => {
      if (agrupation.id === PackageId) {
        lodgingFromPackage = agrupation.items.find(
          (product) => product.SuperCategoryId === 1
        );
      }
    });

    if (lodgingFromPackage) {
      form = {
        arrivalDate: moment
          .utc(lodgingFromPackage.ArrivalDate)
          .format("YYYY-MM-DD"),
        departureDate: moment
          .utc(lodgingFromPackage.DepartureDate)
          .format("YYYY-MM-DD"),
        adults: lodgingFromPackage.AdultCount,
        children: lodgingFromPackage.ChildCount,
      };
    }

    this.setState(
      {
        loadingAddMore: true,
        addMoreModal: true,
        modalComponent: {
          ...this.state.modalComponent,
        },
      },
      () => {
        let baseUrl = getSystemSettings().api;
        let params =
          "/packages/package?id=" +
          getSystemSettings().id +
          "&salesId=" +
          SalesIDRetriever() +
          "&packageId=" +
          PackageId +
          "&startDate=" +
          form.arrivalDate +
          "&endDate=" +
          form.departureDate +
          "&adultCount=" +
          form.adults +
          "&childCount=" +
          form.children +
          "&onlyComponent=" +
          ComponentId +
          (startDate ? "&componentDate=" + startDate : "");
        let url = baseUrl + params;

        if (
          componentData.code !== undefined &&
          componentData.code !== "" &&
          componentData.code !== null
        ) {
          url += "&code=" + componentData.code;
        } else if (
          selectedPromocode &&
          selectedPromocode.inntopiaPackageId === PackageId
        ) {
          url += "&code=" + selectedPromocode.inntopiaCode;
        }

        request({
          url: url,
          method: "GET",
          cancelToken: source.token,
        }).then((result) => {
          let modalComponent = {};
          if (result.data.result) {
            result.data.result.Components.forEach((item) => {
              if (item.ComponentId === ComponentId) {
                modalComponent = item;
              }
            });
          }

          this.setState({
            ...this.state,
            loadingAddMore: false,
            modalComponent: {
              ...modalComponent,
              MinQuantity: component.MinQuantity,
              DefaultQuantity: component.DefaultQuantity,
            },
            lastComponentQueried: component,
            lastComponentDataQueried: componentData,
            selectedDate: startDate ? startDate : modalComponent.SearchDate,
          });
        });
      }
    );
  };

  toggleAddMore = (value) => {
    this.setState({ addMoreModal: value });
  };

  applyPromocode = () => {
    request({
      url: getSystemSettings().api + "/inntopia/cart/setPromocode",
      method: "POST",
      data: {
        id: getSystemSettings().id,
        sessionId: getSessionId(),
        salesId: SalesIDRetriever(),
        packageCode: this.state.promocodeForm.code,
      },
    }).then((result) => {
      let state = this.state;
      if (result.data.PackageId) {
        state.loading = true;
        state.promocodeForm.added = true;
        state.promocodeForm.error = false;
        this.setState(state, () => {
          this.getItinerary("add");
        });
      } else {
        state.promocodeForm.error = true;
        this.setState(state);
      }
    });
  };

  renderSaveItineraryButton = (b2bOnly = false, position = null) => {
    if (this.state.b2bCookie) {
      const options = [
        "Save & Checkout",
        "Save & Continue",
        "Save & Close",
        "Continue Shopping",
      ];
      if (!b2bOnly)
        return (
          <React.Fragment>
            <ButtonGroup
              className="SaveItineraryButton"
              variant="contained"
              aria-label="split button"
            >
              <SpotlioButton
                loading={this.state.loadingSaveItinerary}
                onClick={() => this.handleSaveItineraryButtonClick(options[0])}
              >
                {options[0]}
              </SpotlioButton>
              <SpotlioButton
                color="primary"
                variant="contained"
                size="small"
                className="SaveItineraryArrow"
                aria-owns={
                  this.state.saveItineraryMenuDisplay
                    ? "menu-list-grow"
                    : undefined
                }
                aria-haspopup="true"
                onClick={() => this.handleSaveItineraryMenuDisplay(true)}
              >
                <SpotlioIcon color="#FFFFFF" icon="feather-chevron-down" />
              </SpotlioButton>
            </ButtonGroup>
            <Popper
              className="SaveItineraryOptions"
              open={this.state.saveItineraryMenuDisplay}
              transition
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin: "bottom",
                  }}
                >
                  <Paper id="menu-list-grow">
                    <ClickAwayListener
                      onClickAway={() =>
                        this.handleSaveItineraryMenuDisplay(false)
                      }
                    >
                      <MenuList>
                        {options.map((option, index) => (
                          <MenuItem
                            key={option}
                            selected={
                              index ===
                              this.state.saveItineraryMenuSelectedIndex
                            }
                            onClick={() =>
                              this.handleSaveItineraryButtonClick(
                                options[index]
                              )
                            }
                          >
                            {option}
                          </MenuItem>
                        ))}
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </React.Fragment>
        );
    } else {
      const saveItinerary = getSystemSettings().app.cart.saveItinerary;
      const continueShopping = getSystemSettings().app.cart.continueShopping;
      const itineraryLabel =
        getSystemSettings().app.cart.saveItineraryText || LocaleAsString("cart.buttons.save_itinerary");

      if (saveItinerary) {
        if (
          (position === "top" && saveItinerary.top === true) ||
          (position === "bottom" && saveItinerary.bottom === true)
        ) {
          return (
            <Button
              className="save"
              onClick={() => this.handleOpenB2CSaveItinerary(true)}
            >
              {this.state.width <= 991 && (
                <SpotlioIcon icon="feather-download" />
              )}
              {itineraryLabel}
            </Button>
          );
        } else return null;
      } else if (continueShopping) {
        return (
          <Button
            className="continue"
            onClick={() =>
              this.handleSaveItineraryButtonClick("Continue Shopping")
            }
          >
            Continue shopping
          </Button>
        );
      }
    }
  };

  handleCloseItinerarySavedDiag = () => {
    this.setState({ ...this.state, itinerarySavedDiag: false });
  };

  handleOpenB2CSaveItinerary = (val) => {
    this.setState({
      ...this.state,
      b2cSaveItinerary: val,
      successfullySavedB2CItinerary: false,
      b2cSaveItineraryLoading: false,
      b2cSaveItineraryError: false,
      b2cSaveItineraryForm: {},
    });
  };

  handleB2CSaveItineraryInput = (event) => {
    let b2cForm = this.state.b2cSaveItineraryForm;
    b2cForm[event.target.name] = event.target.value;
    this.setState({ ...this.state, b2cSaveItineraryForm: b2cForm });
  };

  handleRenderSaveItineraryModalContent = () => {
    if (this.state.b2cSaveItineraryError) {
      return (
        <div className="Information">
          <SpotlioIcon icon="status-closed" />
          <p>
            <IntlMessage id="b2c.save_itinerary.error_sending" />
          </p>
        </div>
      );
    } else if (this.state.successfullySavedB2CItinerary) {
      return this.state.width > 991 ? (
        <div className="Information">
          <SpotlioIcon icon="status-open" />
          <p>
            <IntlMessage id="b2c.save_itinerary.successfully_sent" />
          </p>
        </div>
      ) : (
        <div className="successfully">
          <div className="successIcon">
            <SpotlioIcon icon="feather-check-circle" />
          </div>
          <div className="successDesc">
            <IntlMessage id="b2c.save_itinerary.successfully_sent" />
          </div>
        </div>
      );
    } else if (this.state.b2cSaveItineraryLoading) {
      return (
        <div className="loadingb2c">
          <CircularProgress />
        </div>
      );
    } else {
      return this.state.width > 991 ? (
        <React.Fragment>
          <p className="title">
            {
              getSystemSettings().app && getSystemSettings().app.cart && getSystemSettings().app.cart.saveItineraryDescription 
              ? getSystemSettings().app.cart.saveItineraryDescription
              : <IntlMessage id="b2c.save_itinerary.description" />
            }
          </p>
          <div className="GuestForm">
            {getSystemSettings().app.cart.saveItinerary &&
              getSystemSettings().app.cart.saveItinerary.mode &&
              getSystemSettings().app.cart.saveItinerary.mode === "full" && (
                <React.Fragment>
                  <div className="formItem half">
                    <h3>
                      <IntlMessage id="b2c.save_itinerary.first_name" />
                    </h3>
                    <TextField
                      name="firstName"
                      className="input"
                      placeholder={LocaleAsString(
                        "b2c.save_itinerary.first_name"
                      )}
                      value={this.state.b2cSaveItineraryForm.firstName}
                      onChange={(e) => this.handleB2CSaveItineraryInput(e)}
                    />
                  </div>
                  <div className="formItem half">
                    <h3>
                      <IntlMessage id="b2c.save_itinerary.last_name" />
                    </h3>
                    <TextField
                      name="lastName"
                      className="input"
                      placeholder={LocaleAsString(
                        "b2c.save_itinerary.last_name"
                      )}
                      value={this.state.b2cSaveItineraryForm.lastName}
                      onChange={(e) => this.handleB2CSaveItineraryInput(e)}
                    />
                  </div>
                </React.Fragment>
              )}
            <div className="formItem full">
              <h3>
                <IntlMessage id="b2c.save_itinerary.email" />
              </h3>
              <TextField
                name="email"
                className="input"
                placeholder="example@example.com"
                value={this.state.b2cSaveItineraryForm.email}
                onChange={(e) => this.handleB2CSaveItineraryInput(e)}
              />
            </div>
          </div>
        </React.Fragment>
      ) : (
        <>
          <div className="saveIcon">
            <SpotlioIcon icon="feather-download" />
          </div>
          <div className="saveDesc">
            <IntlMessage id="b2c.save_itinerary.description" />
          </div>
          <div className="form">
            <div className="mobileInput">
              <Input
                name="firstName"
                label={LocaleAsString("b2c.save_itinerary.first_name")}
                placeholder={LocaleAsString("b2c.save_itinerary.first_name")}
                value={this.state.b2cSaveItineraryForm.firstName}
                onChange={(e) => this.handleB2CSaveItineraryInput(e)}
              />
            </div>
            <div className="mobileInput">
              <Input
                name="lastName"
                label={LocaleAsString("b2c.save_itinerary.last_name")}
                placeholder={LocaleAsString("b2c.save_itinerary.last_name")}
                value={this.state.b2cSaveItineraryForm.lastName}
                onChange={(e) => this.handleB2CSaveItineraryInput(e)}
              />
            </div>
            <div className="mobileInput">
              <Input
                name="email"
                label={LocaleAsString("b2c.save_itinerary.email")}
                placeholder={"example@example.com"}
                value={this.state.b2cSaveItineraryForm.email}
                onChange={(e) => this.handleB2CSaveItineraryInput(e)}
              />
            </div>
          </div>
        </>
      );
    }
  };

  verifyDisabledSaveButtonForSaveItinerary() {
    const mailSettings = getSystemSettings().app.cart.saveItinerary;
    if (
      this.state.b2cSaveItineraryError ||
      this.state.successfullySavedB2CItinerary
    )
      return false;
    if (this.state.b2cSaveItineraryLoading) return true;
    else {
      if (mailSettings) {
        if (mailSettings.mode === "full") {
          if (
            !this.state.b2cSaveItineraryForm.firstName ||
            !this.state.b2cSaveItineraryForm.lastName ||
            !this.state.b2cSaveItineraryForm.email
          )
            return true;
          else return false;
        } else {
          if (!this.state.b2cSaveItineraryForm.email) return true;
          else return false;
        }
      } else {
        return true;
      }
    }
  }

  getBundleMinQuantity = (product) => {
    if (
      this.state.bundleObject.bundles[this.state.bundleObject.currentIndexModal]
        .minAddOn > 0
    ) {
      return this.state.bundleObject.bundles[
        this.state.bundleObject.currentIndexModal
      ].minAddOn;
    } else {
      return 0;
    }
  };

  getBundleMaxQuantity = (product) => {
    if (
      this.state.bundleObject.bundles[this.state.bundleObject.currentIndexModal]
        .maxAddOn < product.QuantityAvailable
    ) {
      return this.state.bundleObject.bundles[
        this.state.bundleObject.currentIndexModal
      ].maxAddOn;
    } else {
      return product.QuantityAvailable;
    }
  };

  toogleCheckoutDrawer = () =>
    this.setState({ checkoutDrawer: !this.state.checkoutDrawer });

  getBundleQuantity = (quantity, product) => {
    if (quantity !== null && quantity <= this.getBundleMaxQuantity(product)) {
      return quantity;
    } else {
      return 0;
    }
  };

  redirectToSection = (sectionName) => {
    let { categories } = getSystemSettings();
    let category = categories.find((category) => category.code === sectionName);
    if (category && category.href && category.href[0]) {
      this.props.history.push(category.href[0]);
    }

    this.props.history.push("/");
  };

  getLink = (configLink) => {
    if (
      configLink.indexOf("[PROMOCODE]") &&
      getSelectedPromocode() &&
      getSelectedPromocode().inntopiaCode
    ) {
      return configLink.replace(
        "[PROMOCODE]",
        getSelectedPromocode().inntopiaCode
      );
    }
    return configLink;
  };

  getMinQuantity = (component) => {
    if (component.MinQuantity > component.DefaultQuantity)
      return component.MinQuantity;
    if (component.DefaultQuantity >= component.MinQuantity)
      return component.DefaultQuantity;
    return 1;
  };

  getMaxQuantity = (component) => {
    let currentQuantityOnCart = 0;
    this.state.cart.forEach(agrupation => {
      agrupation.items.forEach(item => {
        if (item.PackageComponentId === component.ComponentId) {
          currentQuantityOnCart = item.Quantity;
        }
      })
    })

    return component.MaxQuantityTotal - currentQuantityOnCart;
  }

  getMinQuantityDelete = (item) => {
    if (this.state.selectedPackage && this.state.selectedPackage.Components) {
      const selectedComponent = this.state.selectedPackage.Components.find(
        (comp) => comp.ComponentId === item.PackageComponentId
      );
      if (selectedComponent && selectedComponent.MinQuantity) {
        return selectedComponent.MinQuantity;
      }
    }
    return 1;
  };

  getMaxQuantityDelete = (item) => {
    if (this.state.selectedPackage && this.state.selectedPackage.Components) {
      const selectedComponent = this.state.selectedPackage.Components.find(
        (comp) => comp.ComponentId === item.PackageComponentId
      );
      if (selectedComponent && selectedComponent.MinQuantity) {
        if (selectedComponent.MinQuantity === item.Quantity) {
          return item.Quantity;
        }
        if (selectedComponent.MinQuantity < item.Quantity) {
          return item.Quantity - selectedComponent.MinQuantity;
        }
      }
    }
    return item.Quantity;
  };

  render() {
    const itineraryLabel =
      getSystemSettings().app.cart.saveItineraryText ||
      LocaleAsString("b2c.save_itinerary.title");
    const upsellingText =
      getSystemSettings().app.cart.upsellingText ||
      LocaleAsString("skin.whistler.cart.hotlinks_label2");
    const system = getSystemSettings();
    let availableUpsellings = false;

    if (system.categories) {
      system.categories.forEach((val, idx) => {
        let visible = true;

        if (val.hide) visible = false;
        if (val.hide_upselling) visible = false;

        if (visible) availableUpsellings = true;
      });
    }

    if (this.state.loading === true) {
      return (
        <div>
          <SearchingScreen
            mode="loading"
            section="cart"
            css={{ height: "200px" }}
          />
        </div>
      );
    }

    if (this.state.itinerarySaved) {
      return (
        <React.Fragment>
          <SEO title="Itinerary Saved" />
          <div className="emptyCart">
            <div className="summaryCart">
              <div className="noItems">
                <IntlMessage id="cart.modal.save-itinerary.saved" />
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }

    if (this.state.cart.length <= 0) {
      return (
        <React.Fragment>
          <SEO title="Cart" />
          {this.state.width > 991 ? (
            <SearchingScreen
              message={
                <span className="emptyCartMessage">
                  {getSystemSettings().head.phone ? (
                    <span className="phoneEmptyCart">
                      {getSystemSettings().head.phone.phone} <br></br>
                    </span>
                  ) : null}
                  {getSystemSettings().app &&
                  getSystemSettings().app.cart &&
                  getSystemSettings().app.cart.emptyCartMessage ? (
                    <span>{getSystemSettings().app.cart.emptyCartMessage}</span>
                  ) : (
                    <React.Fragment>
                      <span dangerouslySetInnerHTML={{ __html: LocaleAsString("cart.general.empty2")}} />
                      <IntlMessage id="cart.general.empty2_link" />
                    </React.Fragment>
                  )}
                  {getSystemSettings().app &&
                  getSystemSettings().app.cart &&
                  getSystemSettings().app.cart.returnBackOnEmpty ? (
                    <span className="returnBackWrapper">
                      <Link
                        to={this.getLink(
                          getSystemSettings().app.cart.returnBackOnEmpty.link
                        )}
                        title={
                          getSystemSettings().app.cart.returnBackOnEmpty.label
                        }
                        className="returnBack-link"
                      >
                        {getSystemSettings().app.cart.returnBackOnEmpty.label}
                      </Link>
                    </span>
                  ) : null}
                </span>
              }
              mode="noresults"
              section="cart"
              css={{ height: "200px" }}
            />
          ) : (
            <div className="cartSection">
              <div className="cartMobile">
                <div className="cartContent">
                  <div className="cartIcon">
                    <SpotlioIcon icon="sp2-shopping-cart" />
                  </div>
                  <div className="cartEmpty">Your shopping cart is empty</div>
                  <div className="cartBrowse">Browse by product category:</div>
                  <div className="cartCategories">
                    <TabGenerator isMobile={true} upselling={true} />
                  </div>
                </div>
              </div>
            </div>
          )}
        </React.Fragment>
      );
    }

    if (this.state.displayRequiredItemTypes) {
      return (
        <React.Fragment>
          <SEO title="Cart" />
          <div className="cartSection">
            <div className="requiredItems">
              {this.state.requiredItemTypes.map((itemRequired) => {
                if (itemRequired.enabled) {
                  return (
                    <React.Fragment>
                      <h1>{itemRequired.title}</h1>
                      <p className="requiredItemText">{itemRequired.message}</p>
                      <div
                        onClick={() =>
                          this.redirectToSection(itemRequired.link_section)
                        }
                        className="requiredItemLink"
                      >
                        {itemRequired.link_text}
                      </div>
                    </React.Fragment>
                  );
                }
                return null;
              })}
            </div>
          </div>
        </React.Fragment>
      );
    }

    const summaryClassName = `summary ${
      getSystemSettings().app &&
      getSystemSettings().app.cart &&
      getSystemSettings().app.cart &&
      getSystemSettings().app.cart.summary &&
      getSystemSettings().app.cart.summary.padding &&
      "padding"
    } ${
      getSystemSettings().app &&
      getSystemSettings().app.cart &&
      getSystemSettings().app.cart.summary &&
      getSystemSettings().app.cart.summary.textAlignLeft &&
      "alignLeft"
    }`;
    return (
      <React.Fragment>
        <SEO title="Cart" />
        {this.props.readOnly || this.props.isDrawer ? null : (
          <Breadcrumb
            withBottomMargin
            steps={this.state.steps.list}
            current={this.state.steps.current}
          />
        )}
        <div
          className={(this.props.isDrawer ? "drawer " : " ") + "cartSection"}
        >
          {this.state.width > 991 ? (
            <>
              <div
                className={`topBar ${
                  getSystemSettings().app &&
                  getSystemSettings().app.cart &&
                  getSystemSettings().app.cart.upperCartInline &&
                  "inline"
                }`}
              >
                <div className="title">
                  {LocaleAsString(
                    getSystemSettings().app &&
                      getSystemSettings().app.cart &&
                      getSystemSettings().app.cart.title
                      ? getSystemSettings().app.cart.title
                      : "skin.global.cart.title"
                  )}
                </div>
                <div className="itinerary-id">
                  {this.props.readOnly ? (
                    <React.Fragment>
                      {getSystemSettings().app &&
                      getSystemSettings().app.checkout &&
                      getSystemSettings().app &&
                      getSystemSettings().app.checkout.completedBookingLinks &&
                      getSystemSettings().app.checkout.completedBookingLinks
                        .enabled ? (
                        <div className="waivers">
                          <p>
                            {
                              getSystemSettings().app.checkout
                                .completedBookingLinks.text
                            }
                          </p>
                          <div className="waiverLinks">
                            {getSystemSettings().app.checkout.completedBookingLinks.links.map(
                              (link, idx) => {
                                return (
                                  //eslint-disable-next-line
                                  <a
                                    key={"waiver_" + idx}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    href={link.link}
                                  >
                                    {link.text}
                                  </a>
                                );
                              }
                            )}
                          </div>
                        </div>
                      ) : null}
                      <span className="id">
                        {LocaleAsString("checkout.your.itinerary") + " "} #
                        {this.state.itineraryId}{" "}
                        {" " +
                          LocaleAsString(
                            "checkout.itinerary.successfully_saved"
                          )}
                      </span>
                      {this.renderSaveItineraryButton(false, "top")}
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span className="id">
                        {LocaleAsString("profile.itinerary.title")}
                        {this.state.itineraryId}
                      </span>
                      {this.renderSaveItineraryButton(false, "top")}
                    </React.Fragment>
                  )}
                </div>
              </div>
              <Products
                readOnly={this.props.readOnly}
                getPackage={this.getPackageUpselling.bind(this)}
                selectedPackage={this.state.selectedPackage}
                getBundle={this.getBundle.bind(this)}
                removePackage={this.removePackageModalOpen.bind(this)}
                deleteItem={this.removeItemModalOpen.bind(this)}
                cart={this.state.cart}
                bundleConfig={getSystemSettings().app.bundles}
              />
              <div
                className={
                  (getSystemSettings().app.cart
                    ? getSystemSettings().app.cart.upselling === false
                      ? "noupselling "
                      : " "
                    : " ") + "bottom"
                }
              >
                {getSystemSettings().app.cart
                  ? getSystemSettings().app.cart.upselling === false
                    ? null
                    : availableUpsellings && (
                        <div className="upselling">
                          <h3 className="topTitle">
                            {
                              getSystemSettings().app.cart.upsellingTitle 
                              ? getSystemSettings().app.cart.upsellingTitle
                              : LocaleAsString("promocode.error.continue_shopping")
                            }
                          </h3>
                          <div className="categories">
                            <TabGenerator upselling={true} />
                          </div>
                          {getSystemSettings().app.cart &&
                          getSystemSettings().app.cart.upsellingLink ===
                            false ? null : (
                            <h3 className="bottomTitle">{upsellingText}</h3>
                          )}
                        </div>
                      )
                  : availableUpsellings && (
                      <div className="upselling">
                        <h3 className="topTitle">
                          {LocaleAsString("skin.whistler.cart.hotlinks_label")}
                        </h3>
                        <div className="categories">
                          <TabGenerator upselling={true} />
                        </div>
                        <h3 className="bottomTitle">{upsellingText}</h3>
                      </div>
                    )}
                <div className={summaryClassName}>
                  {getSystemSettings().app &&
                    getSystemSettings().app.cart &&
                    getSystemSettings().app.cart.summary &&
                    getSystemSettings().app.cart.summary.title && (
                      <div className="summaryTitle">
                        {LocaleAsString(
                          getSystemSettings().app.cart.summary.title
                        )}
                      </div>
                    )}
                  {this.state.savings > 0 ? (
                    <div className="summaryLine">
                      <div className="savings">
                        <IntlMessage
                          id={
                            getSystemSettings().app &&
                            getSystemSettings().app.cart &&
                            getSystemSettings().app.cart.savingsText
                              ? getSystemSettings().app &&
                                getSystemSettings().app.cart &&
                                getSystemSettings().app.cart.savingsText
                              : "cart.labels.savings"
                          }
                        />
                      </div>
                      <div className="savings">
                        <Currency float={true} value={this.state.savings} />
                      </div>
                    </div>
                  ) : null}
                  <div className="summaryLine">
                    <div className="summaryName">
                      <IntlMessage id={"cart.labels.subtotal"} />
                    </div>
                    <div className="summaryName">
                      <Currency float={true} value={this.state.total} />
                    </div>
                  </div>
                  {getSystemSettings().app &&
                  getSystemSettings().app.cart &&
                  getSystemSettings().app.cart.hideTaxes ? null : (
                    <div className="summaryLine">
                      <div
                        onClick={() => this.taxesModalOpen(true)}
                        className="taxes"
                      >
                        {LocaleAsString("cart.labels.taxes_fees")}:
                      </div>
                      <div className="summaryName">
                        <Currency
                          float={true}
                          taxes={true}
                          value={this.state.taxes}
                        />
                      </div>
                    </div>
                  )}
                  <div className="summaryLine">
                    <div className="summaryName">
                      {LocaleAsString("cart.taxes.total")}
                    </div>
                    <div className="summaryName total">
                      <Currency
                        float={true}
                        value={this.state.total + this.state.taxes}
                      />
                    </div>
                  </div>
                  <TotalDueNow base={this.state.total} />
                </div>
              </div>
              <div className="extraComponents">
                {getSystemSettings().app.cart &&
                getSystemSettings().app.cart.promocode &&
                !this.props.readOnly ? (
                  <div className="attachPromocode">
                    <IntlMessage
                      className="label"
                      tag={true}
                      id="Do you have a promo code?"
                    />
                    <TextField
                      variant="filled"
                      label={LocaleAsString("Code")}
                      fullWidth
                      type="text"
                      name="promocode"
                      value={this.state.promocodeForm.code}
                      onChange={this.handleFormChange("code", "promocodeForm")}
                    />
                    <Button
                      className="apply"
                      onClick={() => this.applyPromocode()}
                    >
                      <IntlMessage id="Apply promo code" />
                    </Button>
                    {this.state.promocodeForm.error && (
                      <div className="generalMessage error">
                        <IntlMessage id="Code not valid" />
                      </div>
                    )}
                  </div>
                ) : null}
              </div>
              {this.state.affirmData && (
                <React.Fragment>
                  <div className="affirmData">
                    <span>{this.state.affirmData}</span>
                    <img
                      src="https://ik.imagekit.io/spotlio/spotlio/affirm/affirm_Ey6R01OJFg.png"
                      alt="affirmLogo"
                    />
                    <span onClick={() => this.setState({ affirmModal: true })} className="affirmLink">Learn more</span>
                  </div>
                  <Modal
                    open={this.state.affirmModal}
                    className="affirmModal"
                    noCloseButton={true}
                    closeFn={() => this.setState({ affirmModal: false })}
                    footerContent={
                      <Button
                        className="secondary"
                        onClick={() =>
                          this.setState({ affirmModal: false })
                        }
                      >
                        <IntlMessage id="cart.taxes.close" />
                      </Button>
                    }
                  >
                    <div className="body">
                      <iframe frameBorder={0} title="affirm" src={`${system.payment.affirm.apiBaseUrl}/apps/prequal/?public_api_key=${system.payment.affirm.key}&unit_price=${(this.state.total + this.state.taxes) * 100}&page_type=cart&use_promo=true&locale=en_US`} />
                    </div>
                  </Modal>
                </React.Fragment>
              )}
              {this.state.needGuest && (
                <div className="generalMessage error">
                  Attach guest is required to proceed to checkout
                </div>
              )}
              <div
                className={`checkout ${
                  getSystemSettings().app &&
                  getSystemSettings().app.cart &&
                  getSystemSettings().app.cart.lowerCartInline &&
                  "inline"
                }`}
              >
                <SpotlioButton
                  loading={this.state.loadingPayment}
                  className="goToCheckout"
                  onClick={() => this.checkAddOn()}
                >
                  {LocaleAsString("cart.buttons.proceed_checkout")}
                  <SpotlioIcon icon={"feather-chevron-right"} size={24} />
                </SpotlioButton>
                <div className="itinerary-id">
                  {this.renderSaveItineraryButton(true, "bottom")}
                </div>
              </div>
              {getSystemSettings().app.cart.refundPolicy ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: LocaleAsString(
                      getSystemSettings().app.cart.refundPolicy
                    ),
                  }}
                  className="refundPolicy"
                />
              ) : null}
            </>
          ) : (
            <>
              <div className={"cartMobile"}>
                {this.props.readOnly ? (
                  <div className="completedCheckout">
                    <div className="message">
                      <div className="icon">
                        <SpotlioIcon icon="feather-check-circle" />
                      </div>
                      <div className="block">Thank you for your purchase.</div>
                      <div className="block">
                        We’ll send you the receipt soon in a confirmation email.
                      </div>
                      {getSystemSettings().app &&
                      getSystemSettings().app.checkout &&
                      getSystemSettings().app &&
                      getSystemSettings().app.checkout.completedBookingLinks &&
                      getSystemSettings().app.checkout.completedBookingLinks
                        .enabled ? (
                        <>
                          <div className="waiverDesc">
                            {
                              getSystemSettings().app.checkout
                                .completedBookingLinks.text
                            }
                          </div>
                          <ul className="waiverLinks">
                            {getSystemSettings().app.checkout.completedBookingLinks.links.map(
                              (link, idx) => {
                                return (
                                  <li>
                                    {/*eslint-disable-next-line*/}
                                    <a
                                      key={"waiver_" + idx}
                                      target="_blank"
                                      href={link.link}
                                      rel="noopener noreferrer"
                                    >
                                      {link.text}
                                    </a>
                                  </li>
                                );
                              }
                            )}
                          </ul>
                        </>
                      ) : null}
                      {/*LocaleAsString("checkout.your.itinerary") + " "} #{this.state.itineraryId} {" " + LocaleAsString("checkout.itinerary.successfully_saved")*/}
                    </div>
                  </div>
                ) : (
                  <div className="itinerary-id">
                    <span className="id">
                      {LocaleAsString("profile.itinerary.title")}
                      {this.state.itineraryId}
                    </span>
                    {this.renderSaveItineraryButton(false, "top")}
                  </div>
                )}
                <Products
                  readOnly={this.props.readOnly}
                  getPackage={this.getPackageUpselling.bind(this)}
                  selectedPackage={this.state.selectedPackage}
                  getBundle={this.getBundle.bind(this)}
                  removePackage={this.removePackageModalOpen.bind(this)}
                  deleteItem={this.removeItemModalOpen.bind(this)}
                  cart={this.state.cart}
                />
              </div>
              {this.props.readOnly ? null : (
                <div className="checkoutMobile">
                  <div
                    className={
                      this.state.checkoutDrawer
                        ? "checkoutSummary open"
                        : "checkoutSummary"
                    }
                  >
                    <div className="sumup subtotal">
                      <div>
                        <IntlMessage id={"cart.labels.subtotal"} />
                      </div>
                      <div>
                        <Currency float={true} value={this.state.total} />
                      </div>
                    </div>
                    {this.state.savings > 0 ? (
                      <div className="sumup saving">
                        <div>
                          <IntlMessage
                            id={
                              getSystemSettings().app &&
                              getSystemSettings().app.cart &&
                              getSystemSettings().app.cart.savingsText
                                ? getSystemSettings().app &&
                                  getSystemSettings().app.cart &&
                                  getSystemSettings().app.cart.savingsText
                                : "cart.labels.savings"
                            }
                          />
                        </div>
                        <div>
                          <Currency float={true} value={this.state.savings} />
                        </div>
                      </div>
                    ) : null}
                    {getSystemSettings().app &&
                    getSystemSettings().app.cart &&
                    getSystemSettings().app.cart.hideTaxes ? null : (
                      <div
                        onClick={() => this.taxesModalOpen(true)}
                        className="sumup taxes"
                      >
                        <div className="underline">
                          {LocaleAsString("cart.labels.taxes_fees")}
                        </div>
                        <div>
                          <Currency
                            float={true}
                            taxes={true}
                            value={this.state.taxes}
                          />
                        </div>
                      </div>
                    )}
                    <div className="sumup total">
                      <div>Total</div>
                      <div>
                        <Currency
                          float={true}
                          value={this.state.total + this.state.taxes}
                        />
                      </div>
                    </div>
                    {getSystemSettings().app.cart &&
                    getSystemSettings().app.cart.promocode ? (
                      <>
                        <div className="promocode">
                          <div className="field">
                            <IntlMessage
                              className="label"
                              tag={true}
                              id="Do you have a promo code?"
                            />
                            <input
                              className="input"
                              type="text"
                              name="promocode"
                              value={this.state.promocodeForm.code}
                              onChange={this.handleFormChange(
                                "code",
                                "promocodeForm"
                              )}
                              placeholder={LocaleAsString("Code")}
                            />
                          </div>
                          <div
                            className="promocodeCTA"
                            onClick={() => this.applyPromocode()}
                          >
                            <IntlMessage id="Apply" />
                          </div>
                        </div>
                        <div className="invalid">
                          {this.state.promocodeForm.error && (
                            <IntlMessage id="Code not valid" />
                          )}
                        </div>
                      </>
                    ) : null}
                    {this.state.affirmData && (
                      <React.Fragment>
                        <div className="affirmData">
                          <span>{this.state.affirmData}</span>
                          <img
                            src="https://ik.imagekit.io/spotlio/spotlio/affirm/affirm_Ey6R01OJFg.png"
                            alt="affirmLogo"
                          />
                          <span onClick={() => this.setState({ affirmModal: true })} className="affirmLink">Learn more</span>
                        </div>
                        <Modal
                          open={this.state.affirmModal}
                          className="affirmModal"
                          noCloseButton={true}
                          closeFn={() => this.setState({ affirmModal: false })}
                          footerContent={
                            <Button
                              className="secondary"
                              onClick={() =>
                                this.setState({ affirmModal: false })
                              }
                            >
                              <IntlMessage id="cart.taxes.close" />
                            </Button>
                          }
                        >
                          <div className="body">
                            <iframe frameBorder={0} title="affirm" src={`${system.payment.affirm.apiBaseUrl}/apps/prequal/?public_api_key=${system.payment.affirm.key}&unit_price=${(this.state.total + this.state.taxes) * 100}&page_type=cart&use_promo=true&locale=en_US`} />
                          </div>
                        </Modal>
                      </React.Fragment>
                    )}
                  </div>
                  <div className="checkoutCTA">
                    <div
                      className="drawerToggle"
                      onClick={() => this.toogleCheckoutDrawer()}
                    >
                      <div
                        className={
                          this.state.checkoutDrawer ? "icon open" : "icon"
                        }
                      >
                        <SpotlioIcon icon="iw-left_arrow_large" />
                      </div>
                    </div>
                    <div className="proceed" onClick={() => this.checkAddOn()}>
                      Proceed to checkout
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        {this.state.width > 991 ? (
          <Dialog
            open={this.state.removeItemModal}
            title={LocaleAsString("cart.remove_item.title")}
            className="deleteItem"
            closeFn={this.removeItemModalOpen.bind(this, {}, false)}
            footerContent={
              <React.Fragment>
                {this.state.deletedItem.Quantity > 1 &&
                this.state.deletedItem.Grouped === true ? (
                  <React.Fragment>
                    <Button
                      onClick={() =>
                        this.handleDeleteItem(this.state.deletedItem.Quantity)
                      }
                      className="secondary"
                    >
                      Remove All
                    </Button>
                    {this.state.amountToDelete !==
                      this.state.deletedItem.Quantity && (
                      <Button
                        onClick={() =>
                          this.handleDeleteItem(this.state.amountToDelete)
                        }
                        className="secondary"
                      >
                        Remove ({this.state.amountToDelete})
                      </Button>
                    )}
                  </React.Fragment>
                ) : (
                  <Button
                    onClick={() => this.handleDeleteItem()}
                    className="secondary"
                  >
                    Remove Product
                  </Button>
                )}
                <Button
                  onClick={() => this.removeItemModalOpen({}, false)}
                  className="primary"
                  autoFocus
                >
                  Keep Item
                </Button>
              </React.Fragment>
            }
          >
            <div className="body">
              <div>{this.state.deletedItem.SupplierName}</div>
              <div>{this.state.deletedItem.ProductName}</div>
              {this.state.deletedItem.Quantity > 1 &&
              this.state.deletedItem.Grouped === true ? (
                <div className="dropdowndelete">
                  {LocaleAsString("cart.remove_item.amount")}
                  <QuantitySelector
                    showSymbol={"x"}
                    min={this.getMinQuantityDelete(this.state.deletedItem)}
                    max={this.getMaxQuantityDelete(this.state.deletedItem)}
                    default={
                      this.state.amountToDelete > 0
                        ? this.state.amountToDelete
                        : 1
                    }
                    name="items"
                    whenChange={(name, value) =>
                      this.setState({ amountToDelete: value })
                    }
                  />
                </div>
              ) : null}
            </div>
          </Dialog>
        ) : (
          <Dialog
            open={this.state.removeItemModal}
            className="mobileCartModal"
            closeFn={this.removeItemModalOpen.bind(this, {}, false)}
          >
            <div className="removePackage">
              <div className="removeIcon">
                <SpotlioIcon icon="feather-trash" />
              </div>
              <div className="warning">
                {this.state.deletedItem.SupplierName}
              </div>
              <div className="warning">
                You are about to remove “
                <span>{this.state.deletedItem.ProductName}</span>”.
              </div>
              {this.state.deletedItem.Quantity > 1 &&
              this.state.deletedItem.Grouped === true ? (
                <div className="warn">
                  {LocaleAsString("cart.remove_item.amount")}
                  <QuantitySelector
                    showSymbol={"x"}
                    max={this.state.deletedItem.Quantity}
                    default={
                      this.state.amountToDelete > 0
                        ? this.state.amountToDelete
                        : 1
                    }
                    name="items"
                    whenChange={(name, value) =>
                      this.setState({ amountToDelete: value })
                    }
                  />
                </div>
              ) : null}
              <div className="removeFooter column">
                {this.state.deletedItem.Quantity > 1 &&
                this.state.deletedItem.Grouped === true ? (
                  <>
                    <div
                      onClick={() =>
                        this.handleDeleteItem(this.state.deletedItem.Quantity)
                      }
                      className="removeBtn"
                    >
                      Remove All
                    </div>
                    {this.state.amountToDelete !==
                      this.state.deletedItem.Quantity && (
                      <div
                        onClick={() =>
                          this.handleDeleteItem(this.state.amountToDelete)
                        }
                        className="removeBtn"
                      >
                        Remove ({this.state.amountToDelete})
                      </div>
                    )}
                  </>
                ) : (
                  <div
                    onClick={() => this.handleDeleteItem()}
                    className="removeBtn"
                  >
                    Remove Product
                  </div>
                )}
                <div
                  onClick={() => this.removeItemModalOpen({}, false)}
                  className="keepBtn"
                  autoFocus
                >
                  Keep Item
                </div>
              </div>
            </div>
          </Dialog>
        )}
        {this.state.width > 991 ? (
          <Dialog
            open={this.state.removePackageModal}
            title={LocaleAsString("cart.remove_item.title")}
            className="deleteItem"
            closeFn={this.removePackageModalOpen.bind(this, {}, false)}
            footerContent={
              <React.Fragment>
                <Button
                  onClick={() => this.handleDeletePackage()}
                  className="secondary"
                >
                  {LocaleAsString("cart.remove_item.buttons.remove_package")}
                </Button>
                <Button
                  onClick={() => this.removePackageModalOpen({}, false)}
                  className="primary"
                  autoFocus
                >
                  {LocaleAsString("cart.remove_item.buttons.keep")}
                </Button>
              </React.Fragment>
            }
          >
            <div className="body">
              <div>{this.state.deletedPackage.name}</div>
            </div>
          </Dialog>
        ) : (
          <Dialog
            open={this.state.removePackageModal}
            className="mobileCartModal"
            closeFn={this.removePackageModalOpen.bind(this, {}, false)}
          >
            <div className="removePackage">
              <div className="removeIcon">
                <SpotlioIcon icon="feather-trash" />
              </div>
              <div className="warning">
                You are about to remove “
                <span>{this.state.deletedPackage.name}</span>”.
              </div>
              <div className="warn">Are you sure?</div>
              <div className="removeFooter">
                <div
                  className="closeBtn"
                  onClick={() => this.removePackageModalOpen({}, false)}
                >
                  <SpotlioIcon icon="iw-close" />
                </div>
                <div
                  onClick={() => this.handleDeletePackage()}
                  className="removeBtn"
                >
                  {LocaleAsString("cart.remove_item.buttons.remove_package")}
                </div>
              </div>
            </div>
          </Dialog>
        )}

        <Dialog
          open={this.state.itinerarySavedDiag}
          title="Itinerary has been successfully saved!"
          className="deleteItem"
          closeFn={() => this.handleCloseItinerarySavedDiag()}
          footerContent={
            <React.Fragment>
              <Button
                onClick={() => this.regenerateSessionAndRedirect()}
                className="secondary"
              >
                {LocaleAsString("b2b.travel_agent.go_to_dashboard")}
              </Button>
              <Button
                onClick={() => this.handleCloseItinerarySavedDiag()}
                className="primary"
                autoFocus
              >
                {LocaleAsString("b2b.dialog.close")}
              </Button>
            </React.Fragment>
          }
        >
          <div className="body">What would you like to do?</div>
        </Dialog>

        <Dialog
          open={this.state.taxesModal}
          title="Taxes and fees"
          className="taxes"
          closeOnBackDrop={true}
          closeFn={this.taxesModalOpen.bind(this, false)}
          footerContent={
            <React.Fragment>
              <Button
                onClick={() => this.taxesModalOpen(false)}
                className="default"
              >
                {LocaleAsString("cart.taxes.close")}
              </Button>
            </React.Fragment>
          }
        >
          <div className="body">
            {this.state.taxesList.map((tax, idx) => {
              return (
                <div className="feesandtaxes" key={idx}>
                  <div className="name">
                    {tax.FeeTaxTypeName ? tax.FeeTaxTypeName : tax.name}
                    {tax.FeeTaxTypeName !== tax.Description ? (
                      <span className="description">{tax.Description}</span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="price">
                    {tax.Amount === 0 || !tax.Amount ? (
                      <Currency currency="usd" float={true} value={tax.price} />
                    ) : (
                      <Currency
                        currency="usd"
                        float={true}
                        value={tax.Amount}
                      />
                    )}
                  </div>
                </div>
              );
            })}
            {this.state.taxesList.length > 1 ? (
              <div className="totaltaxesandfees">
                <p className="name">
                  {LocaleAsString("activities.cart.total")}
                </p>
                <p className="price">
                  <Currency
                    currency="usd"
                    float={true}
                    value={this.state.taxes}
                  />
                </p>
              </div>
            ) : null}
          </div>
        </Dialog>

        <Modal
          open={this.state.addMoreModal}
          title={
            this.state.addMoreModal
              ? this.state.modalComponent.ComponentName
              : null
          }
          className="addMoreInfo"
          noCloseButton={true}
          closeFn={this.toggleAddMore.bind(this, false)}
          footerContent={
            <Button
              className="secondary"
              onClick={() =>
                this.setState({
                  addMoreModal: false,
                  modalComponent: {},
                  open: null,
                })
              }
            >
              <IntlMessage id="bundle.modal.close" />
            </Button>
          }
        >
          <div className="body">
            {this.state.loadingAddMore !== false ? (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <React.Fragment>
                {this.state.modalComponent.DatesWithProducts && this.getMaxQuantity(this.state.modalComponent) > 0  ? (
                  <div className="dates">
                    {this.state.modalComponent.DatesWithProducts.length > 1 ? (
                      <div className="multipleDates">
                        <IntlMessage
                          tag={true}
                          id="package.cell.dates.choose_day"
                        />
                        <Select
                          MenuProps={{ disableScrollLock: true }}
                          className="Selector"
                          value={this.state.selectedDate}
                          onChange={(e) =>
                            this.getPackageUpselling(
                              this.state.lastComponentQueried,
                              this.state.lastComponentDataQueried,
                              e.target.value
                            )
                          }
                        >
                          {this.state.modalComponent.DatesWithProducts.map(
                            (val, idx) => {
                              return (
                                <MenuItem key={"date" + idx} value={val}>
                                  {moment.utc(val).format(getDateFormat())}
                                </MenuItem>
                              );
                            }
                          )}
                        </Select>
                      </div>
                    ) : (
                      <div className="onlyOne">
                        <IntlMessage id="package.cell.dates.only_one_day_available" />{" "}
                        {moment
                          .utc(this.state.modalComponent.DatesWithProducts[0])
                          .format(getDateFormat())}
                      </div>
                    )}
                  </div>
                ) : null}
                {
                  this.getMaxQuantity(this.state.modalComponent) === 0 
                  ?
                  LocaleAsString("bundle.max_products_exceeded")
                  :
                  <ListGroups
                    dateOfActivity={this.state.modalComponent.SearchDate}
                    minQuantity={this.getMinQuantity(this.state.modalComponent)}
                    maxQuantity={this.getMaxQuantity(this.state.modalComponent)}
                    open={this.state.open}
                    toggleSupplier={this.toggleSupplier.bind(this)}
                    addToCart={this.addToPackage.bind(this)}
                    list={this.state.modalComponent.ComponentItems}
                  />
                }
                
              </React.Fragment>
            )}
          </div>
        </Modal>

        <Modal
          open={
            this.state.loadingBundle === true
              ? true
              : this.state.bundleObject.bundleModal[
                  this.state.bundleObject.currentIndexModal
                ]
          }
          title={
            this.state.bundleObject.bundles.length > 0 &&
            !this.state.loadingBundle
              ? this.state.bundleObject.bundles[
                  this.state.bundleObject.currentIndexModal
                ].bundleName
              : undefined
          }
          className="bundleInfo"
          noCloseButton={true}
          closeFn={toggleBundleModal.bind(this, this.state.bundleObject, false)}
          footerContent={
            this.state.bundleObject.bundles.length > 0 ? (
              <React.Fragment>
                {this.state.bundleObject.bundles[
                  this.state.bundleObject.currentIndexModal
                ].optional !== false ? (
                  <Button
                    className="secondary"
                    onClick={() =>
                      this.setState({
                        bundleObject: toggleBundleModal(
                          this.state.bundleObject,
                          false
                        ),
                      })
                    }
                  >
                    <IntlMessage id="bundle.modal.close" />
                  </Button>
                ) : null}
                <Button
                  className="primary"
                  onClick={() =>
                    this.setState({ loadingBundle: true }, () =>
                      addBundleProducts(
                        this.state.bundleObject.bundles[
                          this.state.bundleObject.currentIndexModal
                        ],
                        (element) =>
                          addBundleToCart(element, this.state.cart).then(() => {
                            this.getItinerary("add");
                          })
                      )
                    )
                  }
                >
                  Add
                </Button>
              </React.Fragment>
            ) : null
          }
        >
          <div className="body">
            {this.state.bundleObject.bundles.length > 0 &&
            !this.state.loadingBundle ? (
              <React.Fragment>
                <div className="originalProduct">
                  <div>
                    <IntlMessage id="bundle.modal.add_on_to" />
                    {" " +
                      this.state.bundleObject.bundles[
                        this.state.bundleObject.currentIndexModal
                      ].productNameBundle}
                  </div>
                  {
                    this.state.bundleObject.bundles[
                      this.state.bundleObject.currentIndexModal
                    ].bundleDescription
                  }
                  <p>
                    {this.state.bundleObject.bundles[
                      this.state.bundleObject.currentIndexModal
                    ].minAddOn !== 0 &&
                    this.state.bundleObject.bundles[
                      this.state.bundleObject.currentIndexModal
                    ].minAddOn !== undefined ? (
                      <React.Fragment>
                        <IntlMessage id="bundle.min.add_on_to" /> :{" "}
                        {" " +
                          this.state.bundleObject.bundles[
                            this.state.bundleObject.currentIndexModal
                          ].minAddOn}
                      </React.Fragment>
                    ) : null}{" "}
                    {this.state.bundleObject.bundles[
                      this.state.bundleObject.currentIndexModal
                    ].maxAddOn !== 0 &&
                    this.state.bundleObject.bundles[
                      this.state.bundleObject.currentIndexModal
                    ].maxAddOn !== undefined ? (
                      <React.Fragment>
                        <IntlMessage id="bundle.max.add_on_to" /> :{" "}
                        {" " +
                          this.state.bundleObject.bundles[
                            this.state.bundleObject.currentIndexModal
                          ].maxAddOn}
                      </React.Fragment>
                    ) : null}
                  </p>
                </div>
                {this.state.bundleObject.bundles[
                  this.state.bundleObject.currentIndexModal
                ].childProducts
                  ? this.state.bundleObject.bundles[
                      this.state.bundleObject.currentIndexModal
                    ].childProducts.map((product, index) => {
                      return (
                        <div
                          className={
                            "productBundle " +
                            (index % 2 === 0 ? "even" : "odd")
                          }
                        >
                          <div className="productName">
                            {product.ProductName}
                          </div>
                          <div className="prices">
                            {product.Savings ? (
                              <div className="discount">
                                {product.Savings.label}
                              </div>
                            ) : null}
                            <Currency
                              onlyOriginal={true}
                              float={true}
                              value={
                                product.QuantitySelected > 1
                                  ? product.Price * product.QuantitySelected
                                  : product.Price
                              }
                            />
                          </div>
                          <div className="stepper">
                            <QuantitySelector
                              showSymbol={"x"}
                              whenChange={(name, value) =>
                                this.setState({
                                  bundleObject: updateBundleAmount(
                                    value,
                                    this.state.bundleObject,
                                    index
                                  ),
                                })
                              }
                              default={
                                this.state.bundleObject.bundles[
                                  this.state.bundleObject.currentIndexModal
                                ].childProducts[index].QuantitySelected
                              }
                              value={this.getBundleQuantity(
                                this.state.bundleObject.bundles[
                                  this.state.bundleObject.currentIndexModal
                                ].childProducts[index].QuantitySelected,
                                product
                              )}
                              onlyDropDown={true}
                              min={this.getBundleMinQuantity(product)}
                              max={this.getBundleMaxQuantity(product)}
                            ></QuantitySelector>
                          </div>
                        </div>
                      );
                    })
                  : this.state.bundleObject.bundles[
                      this.state.bundleObject.currentIndexModal
                    ].ProductList.map((product, index) => {
                      return (
                        <div
                          className={
                            "productBundle " +
                            (index % 2 === 0 ? "even" : "odd")
                          }
                        >
                          <div className="productName">
                            {product.ProductName}
                          </div>
                          <div className="prices">
                            {product.Savings ? (
                              <div className="discount">
                                {product.Savings.label}
                              </div>
                            ) : null}
                            <Currency
                              onlyOriginal={true}
                              float={true}
                              value={product.Price}
                            />
                          </div>
                          <div className="stepper">
                            <NumericStepper
                              whenChange={(name, value) =>
                                this.updateBundleAmount(
                                  value,
                                  this.state.bundleObject.currentIndexModal,
                                  index
                                )
                              }
                              default={0}
                              onlyDropDown={true}
                              min={0}
                              max={product.Quantity}
                            ></NumericStepper>
                          </div>
                        </div>
                      );
                    })}
                <span className="errorAmount">
                  {this.state.bundleObject.incorrectAmount ? (
                    <IntlMessage id="bundle.max.add_on_to_error" />
                  ) : null}
                </span>
              </React.Fragment>
            ) : (
              <CircularProgress />
            )}
          </div>
        </Modal>
        {this.state.width > 991 ? (
          <Dialog
            open={this.state.b2cSaveItinerary}
            title={itineraryLabel}
            className="bundleInfo"
            withCloseButton={true}
            closeFn={() => this.handleOpenB2CSaveItinerary(false)}
            footerContent={
              <React.Fragment>
                <Button
                  className="primary sendEmailQuote"
                  disabled={this.verifyDisabledSaveButtonForSaveItinerary()}
                  onClick={() =>
                    this.state.b2cSaveItineraryError ||
                    this.state.successfullySavedB2CItinerary
                      ? this.handleOpenB2CSaveItinerary(false)
                      : this.saveItinerary("b2c")
                  }
                >
                  <IntlMessage
                    id={
                      this.state.b2cSaveItineraryError ||
                      this.state.successfullySavedB2CItinerary
                        ? "b2c.save_itinerary.close_button"
                        : "b2c.save_itinerary.save_button"
                    }
                  />
                </Button>
              </React.Fragment>
            }
          >
            <div className="SaveItinerary">
              {this.handleRenderSaveItineraryModalContent()}
            </div>
          </Dialog>
        ) : (
          <Dialog
            open={this.state.b2cSaveItinerary}
            className="mobileCartModal"
            withCloseButton={true}
            closeFn={() => this.handleOpenB2CSaveItinerary(false)}
          >
            <div className="SaveItinerary">
              {this.handleRenderSaveItineraryModalContent()}
              {this.state.b2cSaveItineraryLoading ||
              this.state.b2cSaveItineraryError ? null : (
                <div className="dialogFooter">
                  {this.state.b2cSaveItineraryError ||
                  this.state.successfullySavedB2CItinerary ? null : (
                    <div
                      className="closeBtn"
                      onClick={() => this.handleOpenB2CSaveItinerary(false)}
                    >
                      <SpotlioIcon icon="iw-close" />
                    </div>
                  )}
                  <div
                    className={
                      this.verifyDisabledSaveButtonForSaveItinerary()
                        ? "dialogCTA disabled"
                        : "dialogCTA sendEmailQuote"
                    }
                    disabled={this.verifyDisabledSaveButtonForSaveItinerary()}
                    onClick={() =>
                      this.state.b2cSaveItineraryError ||
                      this.state.successfullySavedB2CItinerary
                        ? this.handleOpenB2CSaveItinerary(false)
                        : this.saveItinerary("b2c")
                    }
                  >
                    <IntlMessage
                      id={
                        this.state.b2cSaveItineraryError ||
                        this.state.successfullySavedB2CItinerary
                          ? "Ok"
                          : "b2c.save_itinerary.save_button"
                      }
                    />
                  </div>
                </div>
              )}
            </div>
          </Dialog>
        )}
        {getSystemSettings().app &&
          getSystemSettings().app.modal &&
          getSystemSettings().app.modal.enabled && (
            <ActivitiesModal
              config={getSystemSettings().app.modal}
              onCloseModal={() => this.gotoRegister()}
              open={this.state.activitiesModal}
            />
          )}
      </React.Fragment>
    );
  }
}
